var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTollway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highway"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1e88e5",
    height: 56,
    rx: 5,
    width: 56,
    x: 4,
    y: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fafafa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55 26h-46a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5h30v5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5h2a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7139 24h5.2861a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1h-3a1 1 0 0 0 -.9824.813l-2.2862 12a1 1 0 0 0 .9825 1.187z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 34h-7.5713a1 1 0 0 0 -.9824.813l-3.4287 18a1 1 0 0 0 .9824 1.187h11a1 1 0 0 0 1-1v-18a1 1 0 0 0 -1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5713 34h-7.5713a1 1 0 0 0 -1 1v18a1 1 0 0 0 1 1h11a1 1 0 0 0 .9824-1.187l-3.4287-18a1 1 0 0 0 -.9824-.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 24h5.2861a1 1 0 0 0 .9825-1.187l-2.2862-12a1 1 0 0 0 -.9824-.813h-3a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTollway);
export default __webpack_public_path__ + "static/media/tollway.0c7213cc.svg";
export { ForwardRef as ReactComponent };